import { Injectable } from '@angular/core';
import { CoalService } from 'app/services/coal.service';
import { Store } from '@ngrx/store';
import { AppState, selectUtilsState } from 'app/store/app.states';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FacturaService {
    idFactura?: number = null;
    idEmpresa?: number = null;
    logoEmpresa?: string = "";

    constructor(private readonly store: Store<AppState>,
        private coalService: CoalService) {

        this.store.select(selectUtilsState).subscribe((state: any) => {
            if (state.empresaSeleccionada != null && this.idEmpresa !== state.empresaSeleccionada.id) {
                this.idEmpresa = state.empresaSeleccionada.id;
                this.logoEmpresa = environment.hostBack + state.empresaSeleccionada?.attributes.logo?.data?.attributes.url;
            }
        });
    }

    async getComplementoPago(idFactura: number) {
        try {
            const res = await this.getDataFactura(idFactura, 3);
            const factura = this.mapFactura(res.data[0]);
            return factura;
        }
        catch(error) {
            console.log("factura_error", error);
            throw(error);
        }
    }

    async getFactura(idFactura: number, idTipoComprobante: number = 1) {
        try {
            const res = await this.getDataFactura(idFactura, idTipoComprobante);
            const factura = this.mapFactura(res.data[0]);
            return factura;
        }
        catch(error) {
            console.log("factura_error", error);
            throw(error);
        }
    }

    async getFacturaXml(idFactura: number): Promise<any> {
        try {
            const media = await this.getDataFacturaXml(idFactura);
            return media;
        } catch(error) {
            console.log("xml_error", error);
            throw(error);
        }
    }

    async getComplementoPagoPdf(idFactura: number) {
        try {
            const res = await this.getDataFactura(idFactura, 3);
            const factura   = this.mapFactura(res.data[0]);
            return this.mapComplementoPagoPdf(factura)
        } catch(error) {
            console.error("complementoPago_error", error);
            throw(error);
        }
    }

    async getFacturaPdf(idFactura: number) {
        try {
            const res = await this.getDataFactura(idFactura);
            const factura   = this.mapFactura(res.data[0]);
            return this.mapFacturaPdf(factura);
        } catch(error) {
            console.error("facturaPdf_error", error);
            throw(error);
        }
    }


//#region Mapeo datos

    mapCodigoPostal(dir_codigopostal: any[]) {
        //const cPs = [];
        const asentamientos = [];
        const municipios = [];
        const estados = [];
        const paises = [];

        for(const cp of dir_codigopostal) {
            const dir_asentamiento = cp.attributes?.dir_asentamiento?.data;
            if (!dir_asentamiento) {
                console.warn(`CP ${cp.attributes?.cp}: sin asentamiento asociado, omitiendo`);
                continue;
            }
            const dir_municipio    = dir_asentamiento.attributes?.dir_municipio?.data;
            if (!dir_municipio) {
                console.warn(`CP ${cp.attributes?.cp}: sin municipio asociado, omitiendo`);
                continue;
            }
            const dir_estado       = dir_municipio.attributes?.dir_estado?.data;
            if (!dir_estado) {
                console.warn(`CP ${cp.attributes?.cp}: sin estado asociado, omitiendo`);
                continue;
            }
            const dir_pai          = dir_estado.attributes?.dir_pai?.data;

            /*cPs.push({
                idCp          : cp.id,
                codigoPostal  : cp.attributes.cp,

                asentamiento  : {
                    id            : dir_asentamiento.id,
                    idMunicipio   : dir_municipio.id,
                    idAsentamiento: dir_asentamiento.attributes.idAsentamiento,
                    nombre        : dir_asentamiento.attributes.nombre
                },
                municipio     : {
                    id            : dir_municipio.id,
                    idEstado      : dir_estado.id,
                    idAsentamiento: dir_asentamiento.id,
                    idMunicipio   : dir_municipio.attributes.idMunicipio,
                    nombre        : dir_municipio.attributes.nombre
                },
                estado        : {
                    id            : dir_estado.id,
                    idPais        : dir_pai.id,
                    idMunicipio   : dir_municipio.id,
                    idEstado      : dir_estado.attributes.idEstado,
                    cveEstado     : dir_estado.attributes.cveEstado,
                    nombre: dir_estado.nombre
                },
                pais          : {
                    id            : dir_pai.id,
                    idEstado      : dir_estado.id,
                    idPais        : dir_pai.attributes.idPais,
                    nombre        : dir_pai.attributes.nombre
                },
            });*/

            if(!asentamientos.some(it => it.data.attributes.idAsentamiento == dir_asentamiento.attributes.idAsentamiento))
                asentamientos.push({ idMunicipio: dir_municipio.id, data: dir_asentamiento});

            if(!municipios.some(it => it.data.attributes.idMunicipio == dir_municipio.attributes.idMunicipio))
                municipios.push({ idEstado: dir_estado.id, data: dir_municipio });

            if(!estados.some(it => it.data.attributes.idEstado == dir_estado.attributes.idEstado))
                estados.push({ idPais: dir_pai.id, data: dir_estado });

            if(!paises.some(it => it.data.attributes.idPais == dir_pai.attributes.idPais))
                paises.push({ data: dir_pai });
        }
        return {
            //cp: cPs,
            success: dir_codigopostal.length > 0,
            asentamientos: asentamientos,
            municipios: municipios,
            estados: estados,
            paises: paises
        };
    }

    // mapDireccionStr(dir: any) {
    //     if(dir == null) return "";
    //     const str = `${dir?.calle} No.: ${dir?.noExterior}${!this.isNullOrEmpty(dir?.noInterior) ? ` Interior: ${dir?.noInterior}`: ''}, ${dir?.colonia}, ${dir?.municipio}, ${dir?.estado}, C.P.:${dir?.codigoPostal}`;
    //     return str;
    // }

    mapDireccionStr(dir: any) {
        if (dir == null) return "";
    
        const partesDireccion = [];
    
        // Verifica si la calle es válida y diferente de "-"
        if (!this.isNullOrEmptyDir(dir?.calle) && dir?.calle !== "-") {
            let direccion = `${dir?.calle}`;
            
            // Agrega número exterior si es válido y diferente de "-"
            if (!this.isNullOrEmptyDir(dir?.noExterior) && dir?.noExterior !== "-") {
                direccion += ` No.: ${dir?.noExterior}`;
            }
    
            // Agrega número interior si es válido
            if (!this.isNullOrEmptyDir(dir?.noInterior)) {
                direccion += ` Interior: ${dir?.noInterior}`;
            }
    
            partesDireccion.push(direccion);
        }
    
        // Verifica colonia si no es "undefined" ni vacía
        if (!this.isNullOrEmptyDir(dir?.colonia) && dir?.colonia !== "undefined") {
            partesDireccion.push(`${dir?.colonia}`);
        }
    
        // Verifica municipio si no es vacío
        if (!this.isNullOrEmptyDir(dir?.municipio)) {
            partesDireccion.push(`${dir?.municipio}`);
        }
    
        // Verifica estado si no es vacío
        if (!this.isNullOrEmptyDir(dir?.estado)) {
            partesDireccion.push(`${dir?.estado}`);
        }
    
        // Verifica código postal si no es vacío
        if (!this.isNullOrEmptyDir(dir?.codigoPostal)) {
            partesDireccion.push(`C.P.:${dir?.codigoPostal}`);
        }
    
        return partesDireccion.length > 0 ? partesDireccion.join(', ') : "Información no disponible";
    }
    
    isNullOrEmptyDir(value: any): boolean {
        return value === null || value === undefined || value === '' || value === '-';
    }

    mapComplementoPagoPdf(factura: any) {
        const empresa       = factura.emisor;
        const emp_direccion = factura.direccion_emisor;
        const cliente       = factura.receptor;

        const emisor = {
            direccion: this.mapDireccionStr(emp_direccion?.direccion),
            nombre: empresa?.razonSocial,
            regimen_fiscal: `${empresa.regimen_fiscal.clave}-${empresa.regimen_fiscal.descripcion}`,
            rfc: empresa?.rfc,
            lugar_emision: emp_direccion?.direccion?.codigoPostal,
            email: empresa?.email,
        };

        const receptor = {
            direccion: this.mapDireccionStr(cliente?.direccion),
            nombre: cliente?.nombre,
            regimen_fiscal: `${cliente?.regimen_fiscal.clave}-${cliente?.regimen_fiscal.descripcion}`,
            rfc: cliente?.rfc,
            email: cliente?.email,
        };

        const productos = {
            ClaveProdServ: "84111506",
            Cantidad: "1",
            ClaveUnidad: "ACT",
            Descripcion: "PAGO 01-Sin objeto de impuesto",
            ValorUnitario: "0",
            ObjetoImp: "01",
            Importe: "0",
            Subtotal: "0",
            Total: "0"
        };

        const tproductos = [];

        const docs = factura.complemento_pagos;
        const pagos = docs.pagos;
        const docsRel = docs.docsRel;

        const qr_code = this.mapQR({
            uuid: factura.timbre?.uuid,
            rfc_emisor:emisor.rfc,
            rfc_receptor:receptor.rfc,
            sello_sat:factura.timbre?.sello_sat ?? "".padEnd(95, ""),
            total:0
        });

        const footer = {
            idEstatusFactura: factura.estatus.id == 3 ? 4 : factura.estatus.id, // 4 Cancelado
            NoCertificado: factura.timbre?.no_certificado ?? "",
            cadena_original: factura.timbre?.sello_dgital_sat ?? "".padEnd(95, ""),
            sello_emisor: factura.timbre?.sello ?? "".padEnd(95, ""),
            sello_sat: factura.timbre?.sello_sat ?? "".padEnd(95, ""),
            version: factura.timbre?.version,
            emisor_cert: "",
            fecha_emit: factura.timbre?.fecha_timbrado ?? null,
            sat_cret: factura.timbre?.no_certificado_sat,
            pac: factura.timbre?.rfc_prov_certif ?? "",
            qr: qr_code,
        };

        let body = {
            //logo: { idLogo: 'https://img.freepik.com/vector-premium/icono-empresa-ilustracion-elemento-simple-diseno-simbolo-concepto-empresa-puede-utilizar-web-movil_159242-7784.jpg?w=2000' },
            logo: { idLogo: this.logoEmpresa },
            emisor: emisor,
            receptor: receptor,
            productos: productos,
            tproductos: tproductos,
            pagos: pagos,
            DocsRel: docsRel,
            footer: footer
        };

        return { uuid: factura.timbre?.uuid, body: body };
    }

    mapFacturaPdf(factura: any) {
        const empresa       = factura.emisor;
        const emp_direccion = factura.direccion_emisor;
        const cliente       = factura.receptor;
        const productos     = factura.productos;
        const totales       = factura.totales;

        // const datos_factura = {
        //     nombretit: factura.tipo_comprobante.id == 1 ? 'INGRESO' : (factura.tipo_comprobante.id == 2 ? "EGRESO" : ""),
        //     uuid: factura.timbre?.uuid,
        //     serie1: factura.serie?.nombre,
        //     folio1: factura.folio,
        //     lugar_exp: emp_direccion?.direccion.codigoPostal,
        //     fecha: factura.fechaEmision, //"04/12/2023 01:52:35", //que fecha?
        //     moneda: factura.moneda?.clave,
        //     usoCFDI: `${cliente.uso_factura.clave}-${cliente.uso_factura.descripcion}`,
        //     metodo_pago: factura.metodo_pago.clave,
        //     forma_pago: factura.forma_pago.clave,
        //     condiciones_pago: factura.condiciones_pago,
        //     ingresos: null,
        // };

        const date = new Date(factura.fechaEmision); // Tu fecha inicial
        const options = { timeZone: 'America/Mexico_City' };

        // Obtener las partes de la fecha en la zona horaria específica
        const year = date.toLocaleString('es-MX', { ...options, year: 'numeric' });
        const month = date.toLocaleString('es-MX', { ...options, month: '2-digit' });
        const day = date.toLocaleString('es-MX', { ...options, day: '2-digit' });

        const hours = date.toLocaleString('es-MX', { ...options, hour: '2-digit', hour12: false });
        const minutes = date.toLocaleString('es-MX', { ...options, minute: '2-digit' });
        const seconds = date.toLocaleString('es-MX', { ...options, second: '2-digit' });

        // Construir el formato ISO
        const fechaEmision = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        // Resultado: "14/01/2025, 09:32:25"


        const datos_factura = {
            nombretit: factura.tipo_comprobante?.id == 1 ? 'INGRESO' : (factura.tipo_comprobante?.id == 2 ? "EGRESO" : ""),
            uuid: factura.timbre?.uuid || '',
            serie1: factura.serie?.nombre || '',
            folio1: factura.folio || '',
            lugar_exp: emp_direccion?.direccion?.codigoPostal || '',
            fecha: fechaEmision || '', //"04/12/2023 01:52:35", //que fecha?
            moneda: factura.moneda?.clave || '',
            usoCFDI: cliente?.uso_factura ? `${cliente.uso_factura.clave}-${cliente.uso_factura.descripcion}` : '',
            metodo_pago: factura.metodo_pago?.clave || '',
            forma_pago: factura.forma_pago?.clave || '',
            condiciones_pago: factura.condiciones_pago || '',
            ingresos: null,
        };

        const emisor = {
            //direccion: "AV. CANAL DEL NORTE No.: 10 No. Interior:  Cuauhtémoc Ciudad de México, C.P.: 06280, México",
            direccion: this.mapDireccionStr(emp_direccion?.direccion),
            nombre: empresa?.razonSocial, //"G-NESHA COMMERCE AND RELATED SERVICES",
            regimen_fiscal: `${empresa?.regimen_fiscal.clave}-${empresa?.regimen_fiscal.descripcion}`, //"General de Ley Personas Morales",
            rfc: empresa?.rfc, //"GCR200622A1A"
            email: empresa?.email,
        };

        const receptor = {
            //direccion_: "SUR 1 No.: 100 No. Interior:  Iztapalapa Ciudad de México, C.P.: 09310, México",
            direccion: this.mapDireccionStr(cliente?.direccion),
            nombre: cliente?.nombre,
            regimen_fiscal: `${cliente?.regimen_fiscal.clave}-${cliente?.regimen_fiscal.descripcion}`,
            rfc: cliente?.rfc,
            email: cliente?.email,
        };

        const ex = factura.estatus.id == 2 ? 1: 0;                // 0 previa, 1 normal timbrado
        const idEstatusFactura = factura.estatus.id == 3 ? 4 : 1; // 4 Cancelado
        const emisor_cert = factura.timbre?.no_certificado ?? "";
        const pac = factura.timbre?.rfc_prov_certif ?? "";
        const cadena_original = factura.timbre?.sello_dgital_sat ? `${this.customCadenaOriginal(factura)}`: "".padEnd(95, "");
        const sat_cert = factura.timbre?.no_certificado_sat;
        const sello_sat = factura.timbre?.sello_sat ?? "".padEnd(95, "");
        const fecha_emit = factura.timbre?.fecha_timbrado ?? null;
        const sello_emisor = factura.timbre?.sello ?? "".padEnd(95, "");

        const qr_code = this.mapQR({
            uuid: factura.timbre?.uuid,
            rfc_emisor:emisor.rfc,
            rfc_receptor:receptor.rfc,
            sello_sat:factura.timbre?.sello_sat ?? "".padEnd(95, ""),
            total:totales.Total
        });

        var documentos_relacionados = undefined;
        if(factura.cfdi_relacionado != null && factura.documentos_relacionados.length > 0)
            documentos_relacionados = {
                cfdi_relacionado: factura.cfdi_relacionado,
                documentos: factura.documentos_relacionados
            };

        const global = factura.global;

        console.log('factura_response', productos);
        

        const factura_response = [
            [datos_factura],
            [emisor],
            [receptor],
            productos.map(p => { return {
                clave_pys: p.claveSat,
                cantidad: p.cantidad,
                unidad: p.unidad,
                clave_unidad: p.codigoUnidad,
                n_identificacion: p.idProducto,
                descripcion: p.descripcion,
                pu: this._$(p.precioUnitario),
                importe: this._$(p.importe),
                nombreFormaDescuento: p.nombreFormaDescuento,
                descuento: p.descuento,
                predial: p.predial,
                impuestos: p.impuestos,
                objetoImpuesto: p.objetoImpuesto
            }}),
            [{
                subtotal_total: this._$(totales.Subtotal)
            }],
            [{
                porcentaje_iva: "IVA 16%"
            }],
            [{
                iva: totales.TasaIva
            }],
            [{
                importeDescuento: this._$(totales.Descuento),
                importeIEPS: this._$(totales.IEPS),
                importeISR: this._$(totales.ISR),
                importeIVA: this._$(totales.IVA),
                importeIVARet: this._$(totales.IVARET),
                importeLocales: this._$(0),
                importeSubtotal: this._$(totales.Subtotal),
                importe_total: this._$(totales.Total),
                totalLetra: this.convertirNumeroALetrasConCentavos(this._$(totales.Total)) // Convertir total a letras
            }],
            [{
                logo: "https://forum-kobotoolbox-org.s3.dualstack.us-east-1.amazonaws.com/original/2X/5/5a7b168b37a53310c7be8c1bfc25f024cebedef5.png"
            }],
            [{
                qr: qr_code
            }],
            [{
                ex: ex, // 0 previa, 1 normal
                idEstatusFactura: idEstatusFactura, // 4 Cancelado
                emisor_cert:      emisor_cert,
                pac:              pac,
                cadena_original:  cadena_original,
                sat_cret:         sat_cert,
                sello_sat:        sello_sat,
                fecha_emit:       fecha_emit,
                sello_emisor:     sello_emisor,
            }],
            [],
            [documentos_relacionados],
            [],
            [{
                //idLogo: "https://drive.google.com/uc?id=18w5TX_Yk2QVkeH9TZ6vkb61sceUqdg4p"
                //idLogo: "https://forum-kobotoolbox-org.s3.dualstack.us-east-1.amazonaws.com/original/2X/5/5a7b168b37a53310c7be8c1bfc25f024cebedef5.png"
                idLogo: this.logoEmpresa
            }],
            [global]
        ];

        return factura_response;
    }

    customCadenaOriginal(factura){
        return `||1.1|${factura.timbre?.uuid}|${this.convertToDateTimeString(factura.fechaEmision)}|${factura.timbre?.rfc_prov_certif}|${factura.timbre?.sello_dgital_sat}|${factura.timbre?.no_certificado_sat}||`
    }

    convertToDateTimeString(dateStr: string): string {
        const date = new Date(dateStr);
    
        // Obtener año, mes, día, horas y minutos
        const year = date.getUTCFullYear();
        const month = ('0' + (date.getUTCMonth() + 1)).slice(-2); // Meses empiezan en 0
        const day = ('0' + date.getUTCDate()).slice(-2);
        const hours = ('0' + date.getUTCHours()).slice(-2);
        const minutes = ('0' + date.getUTCMinutes()).slice(-2);
    
        // Formatear como "YYYY-MM-DDTHH:mm"
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    }

    convertirNumeroALetrasConCentavos(num: string): string {
        const unidades = ['Cero', 'Uno', 'Dos', 'Tres', 'Cuatro', 'Cinco', 'Seis', 'Siete', 'Ocho', 'Nueve'];
        const decenas = ['Diez', 'Once', 'Doce', 'Trece', 'Catorce', 'Quince', 'Dieciséis', 'Diecisiete', 'Dieciocho', 'Diecinueve'];
        const decenas2 = ['Veinte', 'Treinta', 'Cuarenta', 'Cincuenta', 'Sesenta', 'Setenta', 'Ochenta', 'Noventa'];
        const centenas = ['Cien', 'Doscientos', 'Trescientos', 'Cuatrocientos', 'Quinientos', 'Seiscientos', 'Setecientos', 'Ochocientos', 'Novecientos'];
    
        function convertirMenorDeMil(n: number): string {
            let texto = '';
            if (n === 100) return 'Cien';
            if (n > 100) {
                texto += centenas[Math.floor(n / 100) - 1] + ' ';
                n = n % 100;
            }
            if (n >= 10 && n < 20) {
                return texto + decenas[n - 10];
            }
            if (n >= 20) {
                texto += decenas2[Math.floor(n / 10) - 2] + (n % 10 > 0 ? ' y ' + unidades[n % 10] : '');
            } else if (n > 0) {
                texto += unidades[n];
            }
            return texto.trim();
        }
    
        function numeroALetras(num: number): string {
            const entero = Math.floor(num);
            const decimal = Math.round((num - entero) * 100);
    
            let resultado = '';
            if (entero >= 1000) {
                resultado += convertirMenorDeMil(Math.floor(entero / 1000)) + ' Mil ';
            }
            resultado += convertirMenorDeMil(entero % 1000);
            resultado += ` Pesos ${decimal}/100 MXN`; // Centavos en formato 00/100 MXN
            return resultado.trim();
        }
    
        // Limpiar el input para eliminar símbolos como '$' y ',' y convertir a número
        const numero = parseFloat(num.replace(/[^0-9.-]+/g, ''));
        return numeroALetras(numero);
    }

    mapFactura(element: any) {
        const fac = element.attributes;
        const idTipoComprobante = fac.cat_tipo_comprobante.data.id;

        const fecha_emision       = this.mapFechaEmision(fac.cat_fecha_emision.data);
        const estatus             = this.mapEstatus(fac.fac_estatus.data);
        const emisor              = this.mapEmisor(fac.ope_empresa.data);
        const direccion_emisor    = this.mapDireccionEmisor(fac.ope_direccion_empresa.data);
        const direccion_serie     = this.mapDireccionSerie(fac.ope_direccion_serie.data);
        const empresa_banco       = this.mapEmpresaBanco(fac.ope_empresa_banco.data);
        const empresa_observacion = this.mapEmpresaObservacion(fac.ope_empresa_observacion.data);
        const receptor            = this.mapReceptor(fac.cli_cliente.data);
        const tipo_comprobante    = this.mapTipoComprobante(fac.cat_tipo_comprobante.data);
        const metodo_pago         = this.mapMetodoPago(fac.cat_metodo_pago.data);
        const forma_pago          = this.mapFormaPago(fac.cat_forma_pago.data);
        const moneda              = this.mapMoneda(fac.cat_moneda.data);
        const cfdi_relacionado    = this.mapCfdiRelacionado(fac.cat_cfdi_relaciondo.data);

        const productos           = idTipoComprobante != 3 ? this.mapProductos(fac.fac_factura_productos.data) : [];
        const totales             = idTipoComprobante != 3 ? this.mapTotales(fac.fac_factura_productos.data) : {};
        const comp_pago           = idTipoComprobante == 3 ? this.mapComplementoPagos(fac.fac_complemento_pagos.data) : { pagos:[], docsRel:[] };
        const docs_relacionados   = this.mapDocRelacionado(fac.fac_factura_doc_relacionados.data);
        const timbrado            = this.mapTimbrado(fac.fac_factura_timbre.data);
        const xml                 = this.mapMedia(fac.xml.data);
        const global              = idTipoComprobante == 5 ? this.mapGlobal(fac.cat_global_periodicidad.data, fac.cat_global_me.data, fac.catGlobalAnio): { 'global': 0 };

        // cat_global_periodicidad: { fields:['clave','periodicidad'] },
        // cat_global_me: { fields:['clave','mes'] },

        //const fecha = new Date(factura.fecha).toLocaleDateString();
        const fechaEmision = fac.fechaEmision; // ?? fecha;

        const factura = {
            folio: fac.folio ?? '',
            fechaEmision: fechaEmision ?? '',
            numero_pedido: fac.numeroPedido,
            tipo_cambio: fac.tipoCambio,
            nombre_banco: fac.nombreBanco,
            condiciones_pago: fac.condicionesPago,
            observacion: fac.observacion,
            es_importado: fac.esImportado,
            numero_cuenta_pago: fac.numeroCuentaPago, // no se
            confirmacion: fac.confirmacion,
            subtotal: fac.subtotal,
            descuento: fac.descuento,
            total: fac.total,

            fecha_emision: fecha_emision,
            estatus: estatus,
            emisor: emisor,
            direccion_emisor: direccion_emisor,
            serie: direccion_serie,
            empresa_banco: empresa_banco,
            empresa_observacion: empresa_observacion,

            receptor: receptor,
            tipo_comprobante: tipo_comprobante,
            metodo_pago: metodo_pago,
            forma_pago: forma_pago,
            moneda: moneda,
            cfdi_relacionado: cfdi_relacionado,

            productos: productos,
            totales: totales,
            complemento_pagos: comp_pago,
            documentos_relacionados: docs_relacionados,
            timbre: timbrado,
            xml: xml,
            global: global
        }
        return factura;
    }

    mapFechaEmision(cat_fecha_emision) {
        if(cat_fecha_emision == null) return null;
        const attr = cat_fecha_emision.attributes;
        return {
            id: cat_fecha_emision.id,
            nombre: attr.nombre,
            dias: attr.dias
        };
    }

    mapEstatus(fac_estatus) {
        if(fac_estatus == null) return null;
        const estatus = fac_estatus.attributes;
        return {
            id: fac_estatus.id,
            nombre: estatus.nombre,
            es_timbrado: estatus.esTimbrado,
            estado_comprobante: estatus.estadoComprobante
        };
    }

    mapDireccionSerie(ope_direccion_serie) {
        if(ope_direccion_serie == null) return null;
        const attr = ope_direccion_serie.attributes;
        return {
            id: ope_direccion_serie.id,
            nombre: attr.nombre,
            descripcion: attr.descripcion,
            folio: attr.folio
        };
    }

    mapBanco(cat_banco) {
        if(cat_banco == null) return null;
        const attr = cat_banco?.attributes;
        return {
            id: cat_banco?.id,
            clave: attr?.clave,
            nombre: attr?.nombre,
            descripcion: attr?.descripcion
        };
    }

    mapEmpresaBanco(ope_empresa_banco) {
        if(ope_empresa_banco == null) return null;
        const attr = ope_empresa_banco?.attributes;
        return {
            id: ope_empresa_banco?.id,
            clabe: attr?.clabe,
            no_cuenta: attr?.noCuenta,
            sucursal: attr?.sucursal,
            titular: attr?.titular,
            default: attr?.default,
            banco: this.mapBanco(attr?.data),
        };
    }

    mapEmpresaObservacion(ope_empresa_observacion) {
        if(ope_empresa_observacion == null) return null;
        const attr = ope_empresa_observacion.attributes;
        return {
            id: ope_empresa_observacion.id,
            nombre: attr.nombre,
            observacion: attr.observacion,
        };
    }

    mapTipoComprobante(cat_tipo_comprobante) {
        if(cat_tipo_comprobante == null) return null;
        const attr = cat_tipo_comprobante.attributes;
        return {
            id: cat_tipo_comprobante.id,
            nombre: attr.nombre,
            data_cfdi_type: attr.dataCfdiType,
            orden: attr.orden,
            portal: attr.portal,
            masivo: attr.masivo,
        };
    }

    mapMetodoPago(cat_metodo_pago) {
        if(cat_metodo_pago == null) return null;
        const attr = cat_metodo_pago.attributes;
        return {
            id: cat_metodo_pago.id,
            clave: attr.clave,
            nombre: attr.nombre,
        };
    }

    mapFormaPago(cat_forma_pago) {
        if(cat_forma_pago == null) return null;
        const attr = cat_forma_pago.attributes;
        return {
            id: cat_forma_pago.id,
            clave: attr.clave,
            descripcion: attr.descripcion,
            bancarizado: attr.bancarizado,
            rfc_del_emisor_de_la_cuenta_ordenante: attr.rfcDelEmisorDeLaCuentaOrdenante,
            cuenta_ordenante: attr.cuentaOrdenante,
            patron_para_cuenta_ordenante: attr.patronParaCuentaOrdenante,
            rfc_del_emisor_de_la_cuenta_beneficiario: attr.rfcDelEmisorDeLaCuentaBeneficiario,
            cuenta_beneficiario: attr.cuentaBeneficiario,
            patron_para_cuenta_beneficiario: attr.patronParaCuentaBeneficiario,
            tipo_cadena_pago: attr.tipoCadenaPago,
            banco_emisor_extranjero: attr.bancoEmisorExtranjero,
            fecha_inicio_de_vigencia: attr.fechaInicioDeVigencia,
            fecha_fin_de_vigencia: attr.fechaFinDeVigencia,
            numero_de_operacion: attr.numeroDeOperacion,
        };
    }

    mapMoneda(cat_moneda) {
        if(cat_moneda == null) return null;
        const attr = cat_moneda.attributes;
        return {
            id: cat_moneda.id,
            clave: attr.clave,
            descripcion: attr.descripcion,
            decimales: attr.decimales,
            porcentaje_variacion: attr.porcentajeVariacion,
        };
    }

    mapCfdiRelacionado(cat_cfdi_relaciondo) {
        if(cat_cfdi_relaciondo == null) return null;
        const attr = cat_cfdi_relaciondo.attributes;
        return {
            id: cat_cfdi_relaciondo.id,
            clave: attr.clave,
            descripcion: attr.descripcion,
        };
    }

    mapDireccion(dir_direccion: any) {
        if(dir_direccion == null) return null;
        const direccion = dir_direccion.attributes;
        const asentamiento = direccion.dir_asentamiento.data?.attributes;
        const municipio = direccion.dir_municipio.data?.attributes;
        const estado = direccion.dir_estado.data?.attributes;
        const pais = direccion.dir_pai.data?.attributes;

        const datos = {
            id: dir_direccion.id,
            calle: direccion.calle,
            noExterior: direccion.noExterior,
            noInterior: direccion.noInterior,
            coloniaManual: direccion.coloniaManual,
            isColoniaManual: direccion.isColoniaManual,
            codigoPostal: direccion.codigoPostal,
            asentamiento: asentamiento?.nombre,
            colonia: `${(direccion?.isColoniaManual ?? false) ? direccion?.coloniaManual : asentamiento?.nombre}`,
            municipio: municipio?.nombre ?? "",
            estado: estado?.nombre ?? "",
            pais: pais?.nombre ?? "",
        };
        return datos
    }

    /*mapDireccionEmisor(fac_factura: any) {
        const empresa = fac_factura.ope_empresa.data;
        const direccion_empresa = fac_factura.ope_direccion_empresa.data;
        //if(empresa == null || direccion_empresa == null) return null;

        const ct = empresa?.attributes;
        const regimen_fiscal = ct.cat_regimen_fiscal.data?.attributes;
        const dir = direccion_empresa?.attributes;

        const emisor = {
            idEmpresa: empresa?.id,
            rfc: ct?.rfc,
            razonSocial: ct?.razonSocial,
            nombreComercial: ct?.nombreComercial,
            folioInicio: ct?.folioInicio,
            fechaConfiguracion: ct?.fechaConfiguracion,
            registroEmisor: ct?.registroEmisor,
            email: ct?.email,
            telefono: ct?.telefono,
            regimen_fiscal: {
                id: ct.cat_regimen_fiscal?.data.id,
                clave: regimen_fiscal?.clave,
                descripcion: regimen_fiscal?.descripcion,
                aplicaFisico: regimen_fiscal?.aplicaFisico,
                aplicaMoral: regimen_fiscal?.aplicaMoral,
            },
            direccion: this.mapDireccion(dir?.dir_direccion?.data)
        };

        return emisor;
    }*/

    mapDireccionEmisor(ope_direccion_empresa: any) {
        const dir = ope_direccion_empresa?.attributes;
        const dir_emisor = {
            id: ope_direccion_empresa?.id,
            nombre: dir?.nombre,
            descripcion: dir?.descripcion,
            direccion: this.mapDireccion(dir?.dir_direccion?.data)
        };

        return dir_emisor;
    }

    mapEmisor(ope_empresa: any) {
        const ct = ope_empresa?.attributes;
        const regimen_fiscal = ct.cat_regimen_fiscal.data?.attributes;

        const emisor = {
            idEmpresa: ope_empresa?.id,
            rfc: ct?.rfc,
            razonSocial: ct?.razonSocial,
            nombreComercial: ct?.nombreComercial,
            folioInicio: ct?.folioInicio,
            fechaConfiguracion: ct?.fechaConfiguracion,
            registroEmisor: ct?.registroEmisor,
            email: ct?.email,
            telefono: ct?.telefono,
            regimen_fiscal: {
                id: ct.cat_regimen_fiscal?.data.id,
                clave: regimen_fiscal?.clave,
                descripcion: regimen_fiscal?.descripcion,
                aplicaFisico: regimen_fiscal?.aplicaFisico,
                aplicaMoral: regimen_fiscal?.aplicaMoral,
            },
        };

        return emisor;
    }

    mapReceptor(cli_cliente: any) {
        if(cli_cliente == null) return null;

        const ct = cli_cliente.attributes;
        const factura = ct.cat_uso_factura.data.attributes;
        const regimen_fiscal = ct.cat_regimen_fiscal.data.attributes;

        const receptor = {
            idCliente: cli_cliente.id,
            nombre: ct.nombre,
            rfc: ct.rfc,
            emailOpcional1: ct.emailOpcional1,
            emailOpcional2: ct.emailOpcional2,
            email: ct.email,
            uso_factura: {
                id: ct.cat_uso_factura.data.id,
                clave: factura.clave,
                descripcion: factura.descripcion,
                aplicaFisico: factura.aplicaFisico,
                aplicaMoral: factura.aplicaMoral,
            },
            regimen_fiscal: {
                id: ct.cat_regimen_fiscal.data.id,
                clave: regimen_fiscal.clave,
                descripcion: regimen_fiscal.descripcion,
                aplicaFisico: regimen_fiscal.aplicaFisico,
                aplicaMoral: regimen_fiscal.aplicaMoral,
            },
            direccion: this.mapDireccion(ct.dir_direccion.data)
        };

        return receptor;
    }

    mapDocRelacionado(fac_factura_doc_relacionados) {
        return fac_factura_doc_relacionados.map(d => {
            return {
                id: d.id,
                uuid: d.attributes.uuid
            };
        });
    }

    mapComplementoPagos(fac_complemento_pagos: any): { pagos: any[], docsRel: any[] } {
        const docsRel = [];
        const pagos = fac_complemento_pagos.map((it: any) => {
            const pago = it.attributes;
            const fpago = it.attributes.cat_forma_pago.data?.attributes;
            const fmoneda = it.attributes.cat_moneda.data?.attributes;
            const docs = this.mapDocumentosRelacionados(it.id, pago.fac_com_pago_documentos.data);
            docsRel.push(...docs);
            return {
                uuid: it.id,
                fpago: fpago?.clave,
                rfccuentao: pago.rfcCuentaOrdenante,
                rfccuentab: pago.rfcCuentaBeneficiario,
                nbanco: pago.nombreBanco,
                fmoneda: fmoneda?.clave,
                fechapago: `${pago.fechaPago}`, // ${pago.horaPago}
            };
        });
        return { pagos:pagos, docsRel:docsRel };
    }

    mapDocumentosRelacionados(id: number, fac_com_pago_documentos: any): any[] {
        const documentos = fac_com_pago_documentos.map((it: any) => {
            const doc = it.attributes;
            // const fpago = doc.cat_metodo_pago.data?.attributes;
            // const fmoneda = doc.cat_moneda.data?.attributes;
            // const impuestos = doc.fac_com_pago_doc_imps.data;
            // const imp_str = this.mapDocumentosRelacionadosImp(impuestos);
            return {
                uuid: id,
                ident: doc.facturaOriginal,
                fpago: '', //fpago?.clave,
                fmoneda: '', //fmoneda?.clave,
                moriginal: this._$(doc.montoOriginal),
                ipagado: this._$(doc.importePagado),
                sinsoluto: this._$(doc.saldoInsoluto),
                serie: doc.serie,
                folio: doc.folio,
                impuestos: {
                    tipo: { id: 1, nombre: '' },
                    impuesto: 0,
                    base: 0,
                    tasa: 0,
                    total: 0,
                }
                //impuestos: imp_str,
            };
        });
        return documentos;
    }

    mapDocumentosRelacionadosImp(fac_com_pago_doc_imps: any[]): any[] {
        const impuestos = fac_com_pago_doc_imps.map((it: any) => {
            const imp = it.attributes
            // Validación defensiva: si cat_impuesto es null, usar valores por defecto
            if (!imp.cat_impuesto?.data) {
                console.warn('cat_impuesto es null para impuesto de documento relacionado:', imp);
                return {
                    tipo: { id: null, nombre: 'N/A' },
                    impuesto: 'Impuesto no definido',
                    base: imp.base,
                    tasa: imp.tasa,
                    total: imp.total,
                };
            }
            
            const timp = imp.cat_impuesto.data?.attributes;
            const tipo = timp?.cat_tipo_impuesto?.data;
            return {
                tipo: { id: tipo?.id ?? null, nombre: tipo?.attributes?.nombre ?? 'N/A' },
                impuesto: timp?.impuesto ?? 'Impuesto no definido',
                base: imp.base,
                tasa: imp.tasa,
                total: imp.total,
            }
        });
        return impuestos;
    }

    mapProductos(fac_factura_productos: any[]) {
        console.log('fac_factura_productos', fac_factura_productos);
        
        const productos = fac_factura_productos.map((it: any) => {
            const fac_producto = it.attributes;
            const producto = fac_producto.pro_producto.data.attributes;
            const forma_descuento = fac_producto.cat_forma_descuento.data?.attributes ?? {};

            let tasaIva = 0;
            let tasaIvaRet = 0;
            let tasaIeps = 0;
            let tasaIsr = 0;

            tasaIva = producto.cat_iva?.data?.attributes.valor ?? 0;
            tasaIvaRet = producto.cat_iva_ret?.data?.attributes.valor ?? 0;
            if(producto.esTasa ?? false) tasaIeps = fac_producto.cat_iep?.data?.attributes.valor ?? 0;
            else tasaIeps = producto.cuotaIeps;
            tasaIsr = producto.cat_isr?.data?.attributes.valor ?? 0;

            let valorDescuento = this.mapDescuentoTipo({
                cantidad: fac_producto.cantidad,
                precioUnitario: fac_producto.precioUnitario,
                descuento: fac_producto.descuento,
                formaDescuento: fac_producto.cat_forma_descuento?.data?.attributes.formaDescuento ?? ''
            });

            const impuestos = this.mapProductosImp(fac_producto.fac_factura_prod_imps?.data);

            const cantidad = fac_producto.cantidad;
            const precioUnitario = fac_producto.precioUnitario;
            const subtotal = cantidad * precioUnitario;
            const precioCantidad = subtotal - valorDescuento;

            const IVA = precioCantidad * tasaIva;
            const IVARET = precioCantidad * tasaIvaRet;
            const IEPS = precioCantidad * tasaIeps;
            const ISR = precioCantidad * tasaIsr;
            const TOTAL = precioCantidad + IVA - IVARET + IEPS - ISR;

            return {
                id: it.id,
                idProducto: fac_producto.pro_producto.data.id,
                claveSat: producto.cat_clave_sat.data.attributes.clave,
                cantidad: fac_producto.cantidad,
                predial: fac_producto.cuentaPredial,

                precioUnitario: fac_producto.precioUnitario,
                importe: fac_producto.precioUnitario * fac_producto.cantidad,
                descripcion: fac_producto.nombre,

                codigoUnidad: producto.cat_unidad.data.attributes.clave,
                unidad: producto.cat_unidad.data.attributes.nombre,

                formaDescuento: fac_producto.cat_forma_descuento.data?.id,
                nombreFormaDescuento: forma_descuento?.formaDescuento,
                descuento: fac_producto.descuento,

                montoImpuestosTotal: 0,

                valorIEPS: IEPS,
                valorISR: ISR,
                valorIva: IVA,
                valorIvaRet: IVARET,

                tasaIva: tasaIva,
                tasaIvaRet: tasaIvaRet,
                tasaIEPS: tasaIeps,
                tasaISR: tasaIsr,

                iva: producto.cat_iva.data?.attributes.descripcion ?? "",
                ivaRet: producto.cat_iva_ret.data?.attributes?.descripcion ?? "",
                impuestos: impuestos,
                total: TOTAL,
                objetoImpuesto: { valor: producto.cat_objeto_impuesto.data.attributes.valor, nombre: producto.cat_objeto_impuesto.data.attributes.nombre }
            };
        });

        return productos;
    }

    mapProductosImp(fac_factura_prod_imps: any[]): any[] {
        const impuestos = fac_factura_prod_imps.map((it: any) => {
            const imp = it.attributes
            // Validación defensiva: si cat_impuesto es null, usar valores por defecto
            if (!imp.cat_impuesto?.data) {
                console.warn('cat_impuesto es null para impuesto:', imp);
                return {
                    tipo: { id: null, nombre: 'N/A' },
                    impuesto: 'Impuesto no definido',
                    clave: 'N/A',
                    base: imp.base,
                    tasa: imp.tasa,
                    importe: imp.total,
                };
            }
            
            const timp = imp.cat_impuesto.data?.attributes;
            const tipo = timp?.cat_tipo_impuesto?.data;
            return {
                tipo: { id: tipo?.id ?? null, nombre: tipo?.attributes?.nombre ?? 'N/A' },
                impuesto: timp?.impuesto ?? 'Impuesto no definido',
                clave: timp?.clave ?? 'N/A',
                base: imp.base,
                tasa: imp.tasa,
                importe: imp.total,
            }
        });
        return impuestos
        //.filter(i => i.importe > 0)
        .sort((a, b) => {
            if(a.tipo.id < b.tipo.id)
                return 1;
            else if(a.tipo.id > b.tipo.id)
                return -1;
            else return 0;
        });
    }

    mapQR({ uuid, rfc_emisor, rfc_receptor, sello_sat, total }: { uuid: string; rfc_emisor: string; rfc_receptor: string; sello_sat: string; total: number }) {
        // https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?id={uuid}&re={emisor}&rr={receptor}&tt={totalFactura}&fe={8ultimos digitos del sello digital}
        // datos qr
        const base_url = "https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx"
        const sello = sello_sat ?? "";
        const sello_8 = sello.length > 0 ? sello.substring(sello.length - 8) : "";
        const qr_code = `?id=${uuid ?? ""}&re=${rfc_emisor}&rr=${rfc_receptor}&tt=${total.toFixed(2)}&fe=${sello_8}`;
        // datos qr
        return base_url + qr_code;
    }

    mapDescuentoTipo({cantidad, precioUnitario, descuento, formaDescuento}: {cantidad: number, precioUnitario: number, descuento: number, formaDescuento: string}) {
        let valorDescuento = 0;

        switch (formaDescuento) {
            case '': valorDescuento = 0; break;
            case '%': valorDescuento = (precioUnitario * cantidad) * (descuento / 100); break;
            case '$': valorDescuento = descuento; break;
        }
        return valorDescuento;
    }

    mapDescuento({cantidad, precioUnitario, descuento, formaDescuento}: {cantidad: number, precioUnitario: number, descuento: number, formaDescuento: number}) {
        let valorDescuento = 0;
        switch (formaDescuento) {
            case 1: valorDescuento = 0; break;
            case 2: valorDescuento = (precioUnitario * cantidad) * (descuento / 100); break;
            case 3: valorDescuento = descuento; break;
        }
        return valorDescuento;
    }

    mapTotales(productos: any[]) {
        console.log('<----- mapTotales()', productos);
    
        const sumatoriasTotales = {
            TasaIva: 0,
            IVA: 0,      // suma
            IVARET: 0,   // suma
            IEPS: 0,     // suma
            ISR: 0,      // suma
            Subtotal: 0, // suma cantidad * precio
            Descuento: 0,// suma descuento
            Total: 0     // suma cantidad * precio + iva - ivaret + ieps - isr
        };
    
        productos.forEach(producto => {
            const p = producto.attributes;
            const cantidad = p.cantidad;
            const precioUnitario = p.precioUnitario;
            const subtotal = cantidad * precioUnitario;
            const producto_attr = p.pro_producto.data.attributes;
    
            // Sumar siempre el subtotal
            sumatoriasTotales.Subtotal += subtotal;
    
            // Calcular el descuento
            const valorDescuento = this.mapDescuentoTipo({
                cantidad: cantidad,
                precioUnitario: precioUnitario,
                descuento: p.descuento,
                formaDescuento: p.cat_forma_descuento.data?.attributes.formaDescuento ?? ''
            });
            sumatoriasTotales.Descuento += valorDescuento;
    
            const precioCantidad = subtotal - valorDescuento;
    
            // Verificar si se debe calcular impuestos (cuando cat_objeto_impuesto es "02")
            const objetoImpuesto = producto_attr.cat_objeto_impuesto.data?.attributes.valor;
            if (objetoImpuesto === "02") {
                // Solo calculamos los impuestos si el valor es "02"
                const tasaIva = producto_attr.cat_iva?.data?.attributes.valor ?? 0;
                const tasaIvaRet = producto_attr.cat_iva_ret?.data?.attributes.valor ?? 0;
                const tasaIeps = producto_attr.esTasa ? producto_attr.cat_iep?.data?.attributes.valor ?? 0 : producto_attr.cuotaIeps;
                const tasaIsr = producto_attr.cat_isr?.data?.attributes.valor ?? 0;
    
                const IVA = precioCantidad * tasaIva;
                const IVARET = precioCantidad * tasaIvaRet;
                const IEPS = precioCantidad * tasaIeps;
                const ISR = precioCantidad * tasaIsr;
                const TOTAL = precioCantidad + IVA - IVARET + IEPS - ISR;
    
                // Sumar los impuestos al total
                sumatoriasTotales.TasaIva = tasaIva;
                sumatoriasTotales.IVA += IVA;
                sumatoriasTotales.IVARET += IVARET;
                sumatoriasTotales.IEPS += IEPS;
                sumatoriasTotales.ISR += ISR;
                sumatoriasTotales.Total += TOTAL;
            } else {
                // Si no aplica impuestos, solo sumamos el precio sin impuestos
                sumatoriasTotales.Total += precioCantidad;
            }
        });
    
        return sumatoriasTotales;
    }

    mapMedia(media: any[]): any[] {
        if(media == null) return null;
        const files = media.map((it: any) => {
            const fmedia = it?.attributes;
            return {
                name: fmedia?.name,
                ext: fmedia?.ext,
                mime: fmedia?.mime,
                size: fmedia?.size,
                url: fmedia?.url
            };
        });
        return files;
    }

    mapTimbrado(fac_factura_timbre: any) {
        if(fac_factura_timbre == null) return null;
        const timbre = fac_factura_timbre?.attributes;
        const timbrado = {
            uuid: timbre?.uuid,
            sello: timbre?.sello,
            certificado: timbre?.certificado,
            no_certificado: timbre?.noCertificado,
            sello_dgital_sat: timbre?.selloDgitalSAT,
            fecha_timbrado: timbre?.fechaTimbrado,
            no_certificado_sat: timbre?.noCertificadoSAT,
            rfc_prov_certif: timbre?.rfcProvCertif,
            sello_cfd: timbre?.selloCFD,
            sello_sat: timbre?.selloSAT,
            version: timbre?.version,
            cfdi_comprobante: timbre?.cfdiComprobante
        };
        return timbrado;
    }

    mapGlobal(global_periodo: any, global_mes: any, global_anio: any): any {
        if(global_periodo == null) return { 'global': 0 } ;
        const gPAtrib = global_periodo?.attributes;
        const gMAtrib = global_mes?.attributes;

        const globalData = {
            'global': 1,
            'lblPeriodo': `${gPAtrib.clave} - ${gPAtrib.periodicidad}`,
            'lblMes': `${gMAtrib.clave} - ${gMAtrib.mes}`,
            'lblAnio': global_anio,
        }
        return globalData;
    }

//#endregion

//#region Servicio Datos

    getDataEmpresaStatus(idEmpresa: number) {
        return new Promise((resolve, reject) => {
            const query = this.getQueryFromObject(this.getEmpresaEstatusQuery());
            this.coalService.getService(`ope-empresas/${idEmpresa}?${query}`).subscribe({
                next: (res: any) => {
                    resolve(res);
                }, error: (error: any) => {
                    reject(error);
                }
            });
        });
    }

    getDataCodigoPostal(cp: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            var object = this.getCodigoPostalQuery();
            const query = `dir-codigos-postales?filters[cp][$eq]=${cp}&` + this.getQueryFromObject(object);
            this.coalService.getService(query).subscribe({
                next: (res: any) => resolve(this.mapCodigoPostal(res.data)),
                error: error => {
                    console.log("codigoPostal_error", error);
                    reject(error);
                }
            });
        });
    }

    getDataMapCodigoPostal(cp: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            const query = `dir-codigos-postales?filters[cp][$eq]=${cp}&populate[dir_asentamiento][populate][dir_municipio][populate][dir_estado][populate][dir_pai][populate]`;
            this.coalService.getService(query).subscribe({
                next: (res: any) => resolve(this.mapCodigoPostal(res.data)),
                error: error => {
                    console.log("codigo_postal_error", error);
                    reject(error);
                }
            });
        });
    }

    getDataFactura(idFactura: number, idTipoComprobante: number = 1): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            var object = this.getFacturaQuery(idTipoComprobante);
            const query = `fac-facturas?filters[id]=${idFactura}
            &populate[cat_tipo_comprobante][populate]=*
            &populate[cat_fecha_emision][populate]=*
            &populate[fac_estatus][populate]=*
            &populate[ope_direccion_empresa][populate][dir_direccion][populate]=dir_municipio,dir_asentamiento,dir_estado,dir_pai
            &populate[ope_direccion_serie][populate]=*
            &populate[ope_empresa_banco][populate]=*
            &populate[ope_empresa_observacion][populate]=*
            &populate[cli_cliente][populate][cat_uso_factura][populate]=*
            &populate[cli_cliente][populate][cat_regimen_fiscal][populate]=*
            &populate[cli_cliente][populate][dir_direccion][populate]=dir_municipio,dir_asentamiento,dir_estado,dir_pai
            &populate[cat_metodo_pago][populate]=*
            &populate[cat_forma_pago][populate]=*
            &populate[cat_moneda][populate]=*
            &populate[cat_cfdi_relaciondo][populate]=*
            &populate[ope_empresa][populate]=cat_regimen_fiscal
            &populate[fac_factura_productos][populate][cat_forma_descuento][populate]=*
            &populate[fac_factura_productos][populate][pro_producto][populate]=cat_objeto_impuesto,cat_iva,cat_isr,cat_iep,cat_iva_ret,cat_clave_sat,cat_unidad
            &populate[fac_factura_productos][populate][fac_factura_prod_imps][populate]=*
            &populate[fac_factura_productos][populate][fac_factura_imp_locales][populate]=*
            &populate[fac_complemento_pagos][populate]=*
            &populate[fac_factura_doc_relacionados][populate]=*
            &populate[fac_factura_timbre][populate]=*
            &populate[xml][populate]=*
            &populate[fac_com_pago_documentos][populate][cat_metodo_pago][populate]=*
            &populate[cat_global_me][populate]=*
            &populate[cat_global_periodicidad][populate]=*
            `;
            this.coalService.getService(query).subscribe({
                next: (res: any) => resolve(res),
                error: error => {
                    console.log("factura_error", error);
                    reject(error);
                }
            });
        });
    }

    getDataEmpresa(idEmpresa: number) {
        var object = this.getEmpresaQuery();
        const url = `ope-empresas/${idEmpresa}?` + this.getQueryFromObject(object);
        return new Promise((resolve, reject) => {
            this.coalService.getService(url)
            .subscribe({
                next: (res: any) => {
                    const cliente = this.mapEmisor(res.data);
                    resolve(cliente);
                },
                error: (error: any) => {
                    reject(error);
                }
            });
        });
    }

    getDataDireccionEmpresa(idDireccion: number) {
        var object = this.getDireccionEmpresaQuery();
        const url = `ope-direccion-empresas/${idDireccion}?` + this.getQueryFromObject(object);
        return new Promise((resolve, reject) => {
            this.coalService.getService(url)
            .subscribe({
                next: (res: any) => {
                    const direccion = this.mapDireccionEmisor(res.data);
                    resolve(direccion);
                },
                error: (error: any) => {
                    reject(error);
                }
            });
        });
    }

    getDataDireccionSerie(id: number) {
        var object = this.getDireccionSerieQuery();
        const url = `ope-direccion-series/${id}?` + this.getQueryFromObject(object);
        return new Promise((resolve, reject) => {
            this.coalService.getService(url)
            .subscribe({
                next: (res: any) => {
                    const direccion = this.mapDireccionEmisor(res.data);
                    resolve(direccion);
                },
                error: (error: any) => {
                    reject(error);
                }
            });
        });
    }

    getDataCliente(idCliente: number) {
        var object = this.getClienteQuery();
        const url = `cli-clientes/${idCliente}?` + this.getQueryFromObject(object);
        return new Promise((resolve, reject) => {
            this.coalService.getService(url)
            .subscribe({
                next: (res: any) => {
                    const cliente = this.mapReceptor(res.data);
                    resolve(cliente);
                },
                error: (error: any) => {
                    reject(error);
                }
            });
        });
    }

    getDataComplementoPago(idFactura: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            var object = this.getFacturaComplementoPagoQuery();
            const query = `fac-facturas/${idFactura}?` + this.getQueryFromObject(object);
            this.coalService.getService(query).subscribe({
                next: (res: any) => resolve(res),
                error: error => {
                    console.log("complementoPago_error", error);
                    reject(error);
                }
            });
        });
    }

    getDataFacturaProductos(idFactura: number): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
            var object = this.getFacturaProductosQuery();
            const query = `fac-facturas/${idFactura}?` + this.getQueryFromObject(object);

            this.coalService.getService(query).subscribe({
                next: (res: { data: any } ) => {
                    const fac = res.data;
                    const productos = this.mapProductos(fac.attributes.fac_factura_productos.data);
                    resolve(productos);
                },
                error: error => {
                    console.log("productos_error", error);
                    reject(error);
                }
            });
        });
    }

    getDataFacturaXml(idFactura: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            var object = this.getFacturaXmlQuery();
            const query = `fac-facturas/${idFactura}?` + this.getQueryFromObject(object);

            this.coalService.getService(query).subscribe({
                next: (res: { data: any } ) => {
                    const fac = res.data.attributes;
                    const media = this.mapMedia(fac.xml.data);
                    resolve(media);
                },
                error: error => {
                    console.log("timbre_error", error);
                    reject(error);
                }
            });
        });
    }

    getDataFacturaTimbre(idFactura: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            var object = this.getFacturaTimbreQuery();
            const query = `fac-facturas/${idFactura}?` + this.getQueryFromObject(object);

            this.coalService.getService(query).subscribe({
                next: (res: { data: any } ) => {
                    const fac = res.data.attributes;
                    const timbre = this.mapTimbrado(fac.fac_factura_timbre.data);
                    resolve(timbre);
                },
                error: error => {
                    console.log("timbre_error", error);
                    reject(error);
                }
            });
        });
    }

//#endregion

//#region Consultas Strapi

    /**
     * ope_direccion_empresa
     * @returns
     */
    getCodigoPostalQuery() {
        const query = {
            fields: ['cp'],
            populate: {
                dir_asentamiento:{ fields: ['idAsentamiento','nombre'],
                    populate: {
                        dir_tipo_asentamiento: { fields:['idTipoAsentamiento','nombre'], populate: { } },
                        dir_municipio: { fields: ['idMunicipio','nombre'],
                            populate: {
                                //dir_municipio: { fields: ['idMunicipio', 'nombre'], populate: { } },
                                //dir_asentamiento: { fields: ['idTipoAsentamiento','nombre'], populate: {  } },
                                dir_estado: { fields:['idEstado','nombre','cveEstado'],
                                    populate: {
                                        dir_pai: { fields:['idPais','nombre'] }
                                    }
                                },
                                //dir_pai: { fields:['idEstado','nombre','cveEstado'], populate: { dir_pai: { fields:['idPais','nombre'] } } },
                            }
                        }
                    }
                }
            }
        };
        return query;
    }

    /**
     * cat_forma_pago
     * @returns
     */
    getFormaPagoQuery() {
        return { fields:[
            'clave',
            'descripcion',
            'bancarizado',
            'rfcDelEmisorDeLaCuentaOrdenante',
            'cuentaOrdenante',
            'patronParaCuentaOrdenante',
            'rfcDelEmisorCuentaDeBeneficiario',
            'cuentaDeBenenficiario',
            'patronParaCuentaBeneficiaria',
            'tipoCadenaPago',
            'bancoEmisorExtranjero',
            'fechaInicioDeVigencia',
            'fechaFinDeVigencia',
            'numeroDeOperacion'
        ] };
    }

    /**
     * dir_direccion
     * @returns
     */
    getDireccionQuery() {
        return { fields: ['calle','noExterior','noInterior','coloniaManual','isColoniaManual','codigoPostal'],
            populate: {
                dir_asentamiento: { fields:['idAsentamiento', 'nombre'] },
                dir_municipio: { fields:['idMunicipio','nombre'] },
                dir_estado: { fields:['idEstado','nombre','cveEstado'] },
                dir_pai: { fields:['idPais','nombre'] },
            }
        };
    }

    /**
     * ope_direccion_empresa
     * @returns
     */
    getDireccionEmpresaQuery() {
        const query = { fields: ['nombre', 'descripcion'],
            populate: {
                dir_direccion: this.getDireccionQuery()
            }
        }
        return query;
    }

    /**
     * ope_direccion_serie
     * @returns
     */
    getDireccionSerieQuery() {
        return { fields: ['nombre','descripcion','folio'] };
    }

    /**
     * ope_empresa
     * @returns
     */
    getEmpresaQuery() {
        const query = { fields: ['rfc','razonSocial','nombreComercial', 'folioInicio', 'fechaConfiguracion', 'registroEmisor', 'email', 'telefono'],
            populate: {
                cat_regimen_fiscal: { fields: ['clave', 'descripcion', 'aplicaFisico', 'aplicaMoral'] },
            }
        };
        return query;
    }

    /**
     * ope_empresa
     * @returns
     */
    getEmpresaEstatusQuery() {
        const query = { fields: ['rfc','razonSocial','nombreComercial', 'folioInicio', 'fechaConfiguracion', 'registroEmisor', 'email', 'telefono'],
            populate: {
                cat_tipo_persona: { fields: ['tipoPersona', 'nombre'] },
                cat_giro: { fields: ['nombre', 'aplicaFisico', 'aplicaMoral'] },
                cat_tamanio_empresa: { fields: ['descripcion'] },
                cat_regimen_fiscal: { fields: ['clave', 'descripcion', 'aplicaFisico', 'aplicaMoral'] },
                ope_empresa_estatus_hs: {
                    populate: { ope_empresa_estatus: { fields: ['nombre','descripcion'] }}
                },
                logo: this.getMediaQuery()
            }
        };
        return query;
    }

    /**
     * ope_empresa
     * @returns
     */
    getEmpresaClienteQuery() {
        const query = { fields: ['rfc','razonSocial','nombreComercial', 'folioInicio', 'fechaConfiguracion', 'registroEmisor', 'email', 'telefono'],
            populate: {
                cli_clientes: this.getClienteQuery()
            }
        };
        return query;
    }

    /**
     * ope_empresa
     * @returns
     */
    getEmpresaClientesQuery(filters = null) {
        const query = { fields: ['rfc','razonSocial','nombreComercial'],
            populate: { cli_clientes: this.getClienteQuery(filters) },
            publicationState: 'live'
        };
        return query;
    }

    /**
     * cli_cliente
     * @returns
     */
    getClienteQuery(filters = null) {
        const query = { fields: ['nombre','rfc','email','emailOpcional1','emailOpcional2','publishedAt'],
            populate: {
                cat_uso_factura: { fields: ['clave','descripcion','aplicaFisico','aplicaMoral'] },
                cat_regimen_fiscal: { fields: ['clave','descripcion','aplicaFisico','aplicaMoral'] },
                dir_direccion: this.getDireccionQuery()
            },
            filters: filters,
            publicationState: 'live'
        };
        return query;
    }

    /**
     * fac_factura_productos
     * @returns
     */
    getProductosQuery() {
        const query = {
            fields: ['noIdentificacion','nombre','precioUnitario','cantidad','descuento'],
            populate: {
                pro_producto: { fields: ['noIdentificacion','nombre','descripcion','precioUnitario','esTasa','cuotaIeps'],
                    populate: {
                        cat_iva: { fields:['nombre','descripcion','valor'] },
                        cat_iva_ret: { fields:['nombre','descripcion','valor'] },
                        cat_iep: { fields:['nombre','descripcion','valor'] },
                        cat_isr: { fields:['nombre','descripcion','valor'] },
                        cat_unidad: { fields:['clave','nombre','simbolo','descripcion'] },
                        cat_objeto_impuesto: { fields: ['nombre','valor'] },
                        cat_clave_sat: { fields: ['clave','descripcion','materialPeligroso'] }
                    }
                },
                cat_forma_descuento: { fields: ['formaDescuento'] },
                fac_factura_prod_imps: { fields: ['base','tasa','total'],
                    populate: {
                        cat_impuesto: { fields:['impuesto','clave'], //,'entidad','aplicaCatalogo'
                            populate: { cat_tipo_impuesto: { fields: ['nombre'] } }
                        }
                    }
                }
            },
        };
        return query;
    }

    /**
     * fac_complemento_pagos
     * @returns
     */
    getComplementoPagoQuery() {
        const query = { fields:['fechaPago','horaPago','montoPago','tipoCambio','numeroOperacion','rfcCuentaOrdenante','cuentaOrdenante','nombreBanco','rfcCuentaBeneficiario','cuentaBeneficiario'],
            populate: {
                cat_moneda: { fields:['clave','descripcion','decimales','porcentajeVariacion'] },
                cat_forma_pago: this.getFormaPagoQuery(),
                fac_com_pago_documentos: { fields:['facturaOriginal', 'montoOriginal','noParcialidad','serie','tipoCambio','importeSaldoAnteriror','importePagado','saldoInsoluto','folio'],
                    populate: {
                        cat_objeto_impuesto: { fields: ['nombre','valor'] },
                        cat_metodo_pago: { fields:['clave','nombre'] },
                        cat_moneda: { fields:['clave','descripcion','decimales','porcentajeVariacion'] },
                        fac_com_pago_doc_imps: { fields:['base','tasa','total'],
                            populate: {
                                cat_impuesto: { fields:['impuesto','clave'], //,'entidad','aplicaCatalogo'
                                    populate: { cat_tipo_impuesto: { fields: ['nombre'] } }
                                }
                            }
                        }
                    }
                },
            }
        };
        return query;
    }

    /**
     * fac_factura_doc_relacionados
     * @returns
     */
    getDocumentosRelacionadosQuery() {
        return { fields: ['uuid'] }
    }

    /**
     * fac_factura_timbre
     * @returns
     */
    getTimbreQuery() {
        return { fields:['sello','certificado','noCertificado','selloDgitalSAT','fechaTimbrado','noCertificadoSAT','rfcProvCertif','selloCFD','selloSAT','uuid','version','cfdiComprobante'] };
    }

    /**
     * fac-factura-xml
     * @returns
     */
    getMediaQuery() {
        return { fields: [
            'name',
            //'alternativeText',
            //'caption',
            //'width',
            //'height',
            //'formats',
            //'hash',
            'ext',
            'mime',
            'size',
            'url',
            //'previewUrl',
            //'provider',
            //'provider_metadata'
        ] };
    }

    getFacQuery() {
        return { fields: [
            'folio',
            'fechaEmision',
            'numeroPedido',
            'tipoCambio',
            'nombreBanco',
            'condicionesPago',
            'observacion',
            'esImportado',
            'numeroCuentaPago',
            'confirmacion',
            'subtotal',
            'descuento',
            'total',
            'catGlobalAnio'
        ] };
    }

    getFacturaProductosQuery() {
        return { ...this.getFacQuery(),
            populate: {
                fac_factura_productos: this.getProductosQuery(),
            }
        }
    }

    getFacturaComplementoPagoQuery() {
        return { ...this.getFacQuery(),
            populate: {
                fac_complemento_pagos: this.getComplementoPagoQuery(),
            }
        }
    }

    getFacturaTimbreQuery() {
        return { ...this.getFacQuery(),
            populate: {
                fac_factura_timbre: this.getTimbreQuery(),
            }
        }
    }

    getFacturaXmlQuery() {
        return { ...this.getFacQuery(),
            populate: {
                xml: this.getMediaQuery(),
            }
        };
    }

    getFacturaQuery(idTipoComprobante: number = 1) {
        return { ...this.getFacQuery(),
            populate: {
                cat_fecha_emision: { fields: ['nombre','dias'] },
                fac_estatus: { fields: ['nombre', 'esTimbrado', 'estadoComprobante'] },
                ope_direccion_empresa: this.getDireccionEmpresaQuery(),
                ope_direccion_serie: this.getDireccionSerieQuery(),
                ope_empresa: { fields: ['rfc','razonSocial','nombreComercial', 'folioInicio', 'fechaConfiguracion', 'registroEmisor', 'email', 'telefono'],
                    populate: {
                        cat_regimen_fiscal: { fields: ['clave', 'descripcion', 'aplicaFisico', 'aplicaMoral'] }
                    }
                },
                ope_empresa_banco: { fields:['clabe','noCuenta','sucursal','titular', 'default'],
                    populate: {
                        cat_banco: { fields: ['clave','nombre','descripcion'] }
                    }
                },
                ope_empresa_observacion: { fields: ['nombre','observacion'] },
                cli_cliente: this.getClienteQuery(),
                cat_tipo_comprobante: { fields: ['nombre','dataCfdiType','orden','portal','masivo'] },
                cat_metodo_pago: { fields: ['clave','nombre'] },
                cat_forma_pago: this.getFormaPagoQuery(),
                cat_moneda: { fields:['clave','descripcion','decimales','porcentajeVariacion'] },
                cat_cfdi_relaciondo: { fields:['clave','descripcion'] },
                fac_complemento_pagos: idTipoComprobante == 3 ? this.getComplementoPagoQuery() : {},
                fac_factura_timbre: this.getTimbreQuery(),
                fac_factura_productos: idTipoComprobante != 3 ? this.getProductosQuery() : {},
                fac_factura_doc_relacionados: this.getDocumentosRelacionadosQuery(),
                xml: this.getMediaQuery(),
                cat_global_periodicidad: { fields:['clave','periodicidad'] },
                cat_global_me: { fields:['clave','mes'] },
            },
        };
    }

//#endregion

//#region Utilidades

    isNullOrEmpty = function(value: any) {
        return !(typeof value === "string" && value.length > 0);
    }

    _$(value: number): string {
        if(value == null) return "";
        return value.toLocaleString('es-MX', {style: 'currency', currency: 'MXN'});
    }

    getQueryFromObject(object: any): string {
        const objString = this.objectToQuery('', object);
        return objString;
    }

    objectToQuery(base:string, object: any): string {
        const objString = Object.keys(object).map(key => {
            if(object[key] == null) return "";
            const value = object[key];
            if(Array.isArray(value)) {
                return value
                    .map((val: any, index: number) => `${base}${base == '' ? key : `[${key}]`}[${index}]=${val}`)
                    .join("&");
            }
            else if((typeof value === "string") || (value instanceof String)) {
                return `${base}${base == '' ? key : `[${key}]`}=${value}`;
            }
            else if((typeof value === "boolean") || (value instanceof Boolean)) {
                return `${base}${base == '' ? key : `[${key}]`}=${value}`;
            }
            else return this.objectToQuery(`${base}${base == '' ? key : `[${key}]`}`, value); //key == 'populate' &&
        }).filter(str => str != '').join('&');
        return objString;
    }

//#endregion

}
